/*
 * Anpassungen an Quantity Breaks, "Frequently bought together" und den
 * Bundle-Deals, ohne die grossen Original-Dateien anzufassen:
 * 1. Farbkacheln statt Dropdown (setzen nur den Wert des <select> und feuern
 *    dessen change-Event, damit Preis- und Warenkorblogik im Original bleibt).
 * 2. Ausverkaufte Farben durchgestrichen statt versteckt. In den Bundle-Karten
 *    sind sie zusaetzlich anklickbar, damit Kunden die Bilder ansehen koennen -
 *    der Hinzufuegen-Knopf wird dann gesperrt.
 * 3. "#1" wird zu "1.".
 * 4. Anteiliger Preis je Varianten-Zeile plus Gesamtpreis-Zeile in der
 *    ausgewaehlten Karte - in Format UND Groesse identisch zum Kartenpreis.
 * 5. Im FBT-Button steht der Gesamtpreis statt des Haekchens.
 * 6. Die Kartenpreise der Quantity Breaks werden auf das Shop-Geldformat
 *    gebracht. Der Block formatiert sie selbst und ignoriert dabei die
 *    Shopify-Einstellung (zeigt z.B. "€59,99" statt "59,99 €").
 */
(function () {
  const SELECTS = [
    '.quantity-breaks__variant-select',
    '.quantity-breaks__variant-option-select',
    '.fbt-variant-tiles .fbt__variant-select',
    '.kokoro-bundle-select',
  ].join(', ');

  /*
   * Bewusst KEIN Quantity-Breaks-Preis als Vorlage: genau der hat ja das
   * falsche Format. Diese Elemente rendert Shopify mit dem money-Filter.
   */
  const FORMAT_SAMPLE = '.fbt__product-sale, .fbt__discounted-total, .fbt__product-compare';

  let moneyFormat = null;

  /*
   * Prefix und Suffix werden ueber die Position der Ziffern bestimmt, nicht
   * per Zeichenklasse. Sonst verschluckt das Muster das Leerzeichen vor dem
   * Euro und aus "59,99 €" wird "59,99€".
   */
  function detectMoneyFormat() {
    const sample = document.querySelector(FORMAT_SAMPLE);
    if (!sample) return null;
    const text = sample.textContent.replace(/ /g, ' ').trim();

    const first = text.search(/\d/);
    if (first === -1) return null;
    let last = -1;
    for (let i = text.length - 1; i >= 0; i--) {
      if (text.charCodeAt(i) >= 48 && text.charCodeAt(i) <= 57) { last = i; break; }
    }
    if (last === -1) return null;

    const number = text.slice(first, last + 1);
    const decimal = number.lastIndexOf(',') > number.lastIndexOf('.') ? ',' : '.';

    return {
      prefix: text.slice(0, first),
      suffix: text.slice(last + 1),
      decimal: decimal,
    };
  }

  function money(cents) {
    if (!moneyFormat) moneyFormat = detectMoneyFormat();

    if (moneyFormat) {
      const locale = moneyFormat.decimal === ',' ? 'de-DE' : 'en-US';
      const number = new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
      return moneyFormat.prefix + number + moneyFormat.suffix;
    }

    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    const locale = document.documentElement.lang || 'de-DE';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* Liest einen Betrag aus beliebig formatiertem Text und gibt Cent zurueck. */
  function parseMoney(text) {
    const match = String(text).replace(/\s/g, '').match(/[\d.,]+/);
    if (!match) return null;
    const digits = match[0];
    const decimalIndex = Math.max(digits.lastIndexOf(','), digits.lastIndexOf('.'));
    let cents;
    if (decimalIndex > -1 && digits.length - decimalIndex - 1 === 2) {
      const whole = digits.slice(0, decimalIndex).replace(/[.,]/g, '');
      const fraction = digits.slice(decimalIndex + 1);
      cents = parseInt(whole || '0', 10) * 100 + parseInt(fraction, 10);
    } else {
      cents = parseInt(digits.replace(/[.,]/g, ''), 10) * 100;
    }
    return isNaN(cents) ? null : cents;
  }

  /* Bringt die selbst formatierten Kartenpreise auf das Shop-Format. */
  function normalizeCardPrices() {
    document
      .querySelectorAll('.quantity-breaks__price, .quantity-breaks__original-price')
      .forEach(function (el) {
        if (el.querySelector('*')) return;
        const cents = parseMoney(el.textContent);
        if (cents == null) return;
        const formatted = money(cents);
        if (el.textContent.trim() !== formatted) el.textContent = formatted;
      });
  }

  /* Uebernimmt Schriftgroesse und -staerke des Kartenpreises 1:1. */
  function matchPriceTypography() {
    const priceSample = document.querySelector('.quantity-breaks__price');
    const compareSample = document.querySelector('.quantity-breaks__original-price');
    if (!priceSample) return;

    const totals = document.querySelectorAll('.qb-total__value');
    if (!totals.length) return;
    const price = getComputedStyle(priceSample);
    totals.forEach(function (el) {
      if (el.style.fontSize !== price.fontSize) el.style.fontSize = price.fontSize;
      if (el.style.fontWeight !== price.fontWeight) el.style.fontWeight = price.fontWeight;
      if (el.style.lineHeight !== price.lineHeight) el.style.lineHeight = price.lineHeight;
    });

    if (!compareSample) return;
    const compare = getComputedStyle(compareSample);
    document.querySelectorAll('.qb-total__value s').forEach(function (el) {
      el.style.fontSize = compare.fontSize;
      el.style.fontWeight = compare.fontWeight;
    });
  }

  function sync(select, tiles) {
    for (const tile of tiles.children) {
      tile.classList.toggle('is-active', tile.dataset.value === select.value);
    }
  }

  /*
   * Bundle-Karten: ausverkaufte Farbe darf angesehen, aber nicht gekauft
   * werden. Deshalb wird der Hinzufuegen-Knopf gesperrt, solange eine nicht
   * lieferbare Farbe gewaehlt ist.
   */
  function updateBundleAvailability(select) {
    const card = select.closest('.bundle-product-card');
    if (!card) return;
    const button = card.querySelector('.bundle-product-card__add-button');
    if (!button) return;

    const option = select.options[select.selectedIndex];
    const soldOut = !!(option && option.disabled);
    const productAvailable = card.dataset.productAvailable !== 'false';

    button.disabled = soldOut || !productAvailable;
    if (soldOut) {
      button.setAttribute('title', 'Diese Farbe ist aktuell ausverkauft');
    } else {
      button.removeAttribute('title');
    }
  }

  /*
   * Quantity Breaks liefern data-swatch-background, FBT data-variant-img,
   * die Bundle-Deals data-image.
   */
  function tileBackground(option) {
    if (option.dataset.swatchBackground) return option.dataset.swatchBackground;
    if (option.dataset.variantImg) return 'url(' + option.dataset.variantImg + ')';
    if (option.dataset.image) return 'url(' + option.dataset.image + ')';
    return null;
  }

  function tileLabel(option) {
    return (option.dataset.variantLabel || option.textContent || '').trim();
  }

  function buildTiles(select) {
    if (select.dataset.qbTiles === 'done') return;
    const options = Array.from(select.options);
    if (options.length < 2) return;

    /*
     * In den Bundle-Karten sind auch ausverkaufte Farben anklickbar. Bei den
     * Paket-Angeboten und im FBT bleiben sie gesperrt, weil dort die Auswahl
     * direkt in den Kauf laeuft.
     */
    const allowSoldOut = select.classList.contains('kokoro-bundle-select');

    const tiles = document.createElement('div');
    tiles.className = 'qb-tiles';

    for (const option of options) {
      const label = tileLabel(option);
      const tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'qb-tile';
      tile.dataset.value = option.value;
      tile.title = option.disabled ? label + ' (ausverkauft)' : label;
      tile.setAttribute('aria-label', tile.title);

      const background = tileBackground(option);
      if (background) tile.style.setProperty('--qb-tile-bg', background);

      if (option.disabled) tile.classList.add('is-unavailable');

      if (option.disabled && !allowSoldOut) {
        tile.disabled = true;
      } else {
        tile.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          sync(select, tiles);
          updateBundleAvailability(select);
        });
      }
      tiles.appendChild(tile);
    }

    select.insertAdjacentElement('afterend', tiles);
    select.dataset.qbTiles = 'done';

    const wrapper =
      select.closest('.quantity-breaks__variant-picker-select-wrapper') || select.parentElement;
    if (wrapper) wrapper.classList.add('qb-has-tiles');

    select.addEventListener('change', function () {
      sync(select, tiles);
      updateBundleAvailability(select);
    });
    sync(select, tiles);
    updateBundleAvailability(select);
  }

  /* Aus "#1" wird "1." - idempotent, laeuft gefahrlos mehrfach. */
  function renumber() {
    document.querySelectorAll('.quantity-breaks__variant-picker-number').forEach(function (label) {
      const text = label.textContent.trim();
      if (text.charAt(0) === '#') label.textContent = text.slice(1) + '.';
    });
  }

  function ensure(parent, className, tag) {
    let el = parent.querySelector(':scope > .' + className);
    if (!el) {
      el = document.createElement(tag || 'div');
      el.className = className;
      parent.appendChild(el);
    }
    return el;
  }

  /*
   * Der Kartenpreis wird so auf die Zeilen verteilt, dass die Summe exakt
   * aufgeht - die ersten Zeilen bekommen den uebrigen Cent.
   */
  function addPrices(card) {
    const rows = card.querySelectorAll('.quantity-breaks__variant-picker-row');
    const quantity = parseInt(card.dataset.quantity, 10) || 0;
    const total = parseInt(card.dataset.finalPriceCents, 10);
    const compare = parseInt(card.dataset.comparePriceCents, 10);
    const content = card.querySelector('.quantity-breaks__content');
    const isActive = card.classList.contains('quantity-breaks__card--active');
    const existingTotal = content ? content.querySelector(':scope > .qb-total') : null;
    /* Zusatzprodukt aus "+ Fusswaermer dazu" (kokoro-fussset.js) zaehlt im aktiven Paket mit. */
    const extra = isActive && window.kokoroAddon ? window.kokoroAddon.summe() : null;
    const hasExtra = !!(extra && extra.cents > 0);
    /* Gesamtpreis unten nur bei Mehrfach-Paketen oder mit Zusatzprodukt. */
    const expanded = quantity > 1 || hasExtra;

    if (!isActive || !expanded) {
      if (existingTotal) existingTotal.remove();
    }

    if (!quantity || isNaN(total)) return;

    /*
     * Gruenes Schild mit der Ersparnis in Euro: bei zugeklappten Paketen hinter dem
     * Paketnamen, bei aufgeklappten mit Gesamtpreis-Zeile dort (inkl. Zusatzprodukte).
     */
    const showTotal = isActive && expanded && !!content;
    const titleEl = card.querySelector('.quantity-breaks__quantity-title');
    if (titleEl) {
      let pctEl = titleEl.querySelector(':scope > .qb-pct');
      const pct = !showTotal && !isNaN(compare) && compare > total ? Math.round(((compare - total) / compare) * 100) : 0;
      if (pct > 0) {
        if (!pctEl) {
          pctEl = document.createElement('span');
          pctEl.className = 'qb-pct';
          titleEl.appendChild(pctEl);
        }
        const pctText = '−' + money(compare - total);
        if (pctEl.textContent !== pctText) pctEl.textContent = pctText;
      } else if (pctEl) {
        pctEl.remove();
      }
    }

    const base = Math.floor(total / quantity);
    const rest = total - base * quantity;
    const compareBase = isNaN(compare) ? null : Math.floor(compare / quantity);

    rows.forEach(function (row, index) {
      const priceEl = ensure(row, 'qb-row-price', 'span');
      const value = base + (index < rest ? 1 : 0);
      let html = money(value);
      if (compareBase && compare > total) {
        html += ' <s>' + money(compareBase) + '</s>';
      }
      /* Nur schreiben, wenn sich etwas aendert - sonst loest jedes Schreiben den Beobachter erneut aus. */
      if (priceEl.dataset.kokoroHtml !== html) {
        priceEl.innerHTML = html;
        priceEl.dataset.kokoroHtml = html;
      }
    });

    if (showTotal) {
      const totalRow = ensure(content, 'qb-total', 'div');
      const sum = total + (hasExtra ? extra.cents : 0);
      const sumCompare = (isNaN(compare) ? total : compare) + (hasExtra ? extra.compare : 0);
      let value = money(sum);
      if (sumCompare > sum) {
        value += ' <s>' + money(sumCompare) + '</s>';
      }
      const badge = sumCompare > sum ? '<span class="qb-pct">−' + money(sumCompare - sum) + '</span>' : '';
      const totalHtml = '<span class="qb-total__label">Gesamtpreis' + badge + '</span><span class="qb-total__value">' + value + '</span>';
      if (totalRow.dataset.kokoroHtml !== totalHtml) {
        totalRow.innerHTML = totalHtml;
        totalRow.dataset.kokoroHtml = totalHtml;
      }
    }
  }

  /*
   * Gesamtpreis in den FBT-Button spiegeln. Bewusst als eigenes span, denn der
   * Original-Block schreibt nur in [data-fbt-button-text].
   */
  function syncBundleButtonTotal() {
    document.querySelectorAll('frequently-bought-together').forEach(function (root) {
      const totalEl = root.querySelector('[data-fbt-discounted-total]');
      const button = root.querySelector('.fbt__button');
      if (!totalEl || !button) return;

      let label = button.querySelector('.fbt-button-total');
      if (!label) {
        label = document.createElement('span');
        label.className = 'fbt-button-total';
        button.appendChild(label);
      }

      const text = totalEl.textContent.trim();
      if (label.textContent !== text) label.textContent = text;
    });
  }

  function init() {
    document.querySelectorAll(SELECTS).forEach(buildTiles);
    renumber();
    normalizeCardPrices();
    document.querySelectorAll('.quantity-breaks__card').forEach(addPrices);
    matchPriceTypography();
    syncBundleButtonTotal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Fuer kokoro-fussset.js: Geldformat und Preis-Neuberechnung von aussen. */
  window.kokoroMoney = money;
  window.kokoroRefreshPrices = function () {
    document.querySelectorAll('.quantity-breaks__card').forEach(addPrices);
    matchPriceTypography();
  };

  /* Auswahlwechsel: der Block setzt die aktive Klasse, wir ziehen nach. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.quantity-breaks__card, frequently-bought-together, .bundle-product-card')) return;
    requestAnimationFrame(init);
  });

  /* Bildschirmbreite geaendert: Schriftgroessen neu abgleichen. */
  let resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(matchPriceTypography, 150);
  });

  /* Der Theme-Editor rendert Bloecke neu, deshalb beobachten wir Nachschub. */
  /* Nur auf Aenderungen in den eigenen Bereichen reagieren, nicht auf jede Aenderung der Seite. */
  const RELEVANT = '.quantity-breaks__container, .quantity-breaks__card, frequently-bought-together, .bundle-product-card, .bundle-deals, ' + SELECTS;
  function betrifft(records) {
    for (const record of records) {
      const t = record.target;
      if (t.nodeType === 1 && t.closest(RELEVANT)) return true;
      for (const n of record.addedNodes) {
        if (n.nodeType === 1 && (n.matches(RELEVANT) || n.querySelector(RELEVANT))) return true;
      }
    }
    return false;
  }
  let pending = false;
  new MutationObserver(function (records) {
    if (pending || !betrifft(records)) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; init(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*
 * --- Warenkorb-Upsell "Kunden kauften auch": Farbe direkt waehlen ---
 *
 * Bisher oeffnete ein Klick auf den Plus-Knopf ein Popup, in dem die Farbe
 * ausgewaehlt werden musste. Zwei Schritte fuer etwas, das eine Zeile weiter
 * oben schon sichtbar ist.
 *
 * Wie das Theme entscheidet (cart-upsell.js, handleButtonClick):
 *   button.dataset.hasVariants === "true" ? openVariantPopup(...) : handleAddToCart(...)
 * Mehr braucht es nicht. Wir haengen unter den Titel dieselben Farbkacheln wie
 * bei den Quantity Breaks, schreiben die gewaehlte Variante an den Knopf und
 * setzen hasVariants auf false. Das Theme legt dann direkt in den Warenkorb,
 * mit seiner eigenen Logik, seinen Events und seinem Section-Neuaufbau. Wir
 * bauen nichts davon nach.
 *
 * Die erste lieferbare Farbe wird vorausgewaehlt, damit der Knopf sofort
 * funktioniert. Ausverkaufte Farben bleiben sichtbar, aber gesperrt.
 *
 * Absichtliche Grenzen:
 * - Nur bei Produkten mit GENAU EINER Option (bei uns "Farbe"). Haette ein
 *   Produkt zusaetzlich Groesse, waere eine Kachelreihe irrefuehrend, dann
 *   bleibt das Popup.
 * - Der Preis in der Karte wird nicht angefasst. Bei uns kosten alle Farben
 *   eines Produkts gleich viel. Sollte sich das aendern, muss das hier mit.
 *
 * Die Optik kommt aus .qb-tiles / .qb-tile in kokoro-custom.css, damit die
 * Kacheln ueberall im Shop gleich aussehen.
 */
(function () {
  const KARTE = '.cart-upsell-product-card';
  const KNOPF = '.cart-upsell-product-card__button';
  const geladen = new Map();
  /* Gewaehlte Farbe je Produkt merken, damit sie den Neuaufbau der Karte ueberlebt. */
  const gewaehlt = new Map();

  function produkt(handle) {
    if (!geladen.has(handle)) {
      geladen.set(
        handle,
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; })
      );
    }
    return geladen.get(handle);
  }

  /* Kleine Fassung vom CDN holen - Kacheln 34 px, Vorschaubild rund 60 px. */
  function klein(src, breite) {
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', String(breite || 120));
      return url.href;
    } catch (e) {
      return src;
    }
  }

  /*
   * Neben der Kachel wechselt auch das grosse Vorschaubild der Karte. Das
   * Original-Bild wird einmal gesichert, damit ein Zurueckschalten wieder
   * exakt dort landet, wo das Theme gestartet ist.
   */
  function bildTauschen(karte, kachel) {
    const img = karte.querySelector('.cart-upsell-product-card__image-img');
    if (!img) return;

    if (!img.dataset.kokoroOriginal) {
      img.dataset.kokoroOriginal = img.getAttribute('src') || '';
    }

    const quelle = kachel.dataset.bild || img.dataset.kokoroOriginal;
    if (!quelle) return;

    const neuesBild = klein(quelle, 300);
    if (img.getAttribute('src') === neuesBild) return;

    img.setAttribute('src', neuesBild);
    /* srcset wuerde sonst gewinnen und das alte Bild weiter anzeigen. */
    img.removeAttribute('srcset');
  }

  /* Schreibweise wie im Theme, nachgemessen: Zahl, ein Leerzeichen, Euro. */
  function geld(cents) {
    return (
      (cents / 100).toLocaleString('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + ' €'
    );
  }

  /*
   * Preis und Streichpreis gehoeren zur gewaehlten Farbe.
   *
   * Das Theme setzt beides beim Aufbau der Karte aus der ersten Variante und
   * ruehrt es danach nur an, wenn sein eigenes Auswahlfeld benutzt wird. Das
   * ist bei uns ausgeblendet, also blieb der Preis stehen, auch wenn die
   * gewaehlte Farbe einen anderen hat. Sichtbar wurde das daran, dass mal ein
   * Streichpreis erschien und mal nicht.
   *
   * Die Betraege kommen aus derselben Produktdatei, aus der auch die Kacheln
   * gebaut werden. Der Streichpreis wird ausgeblendet statt geleert, damit er
   * beim Wechsel auf eine Farbe mit Rabatt wieder auftauchen kann.
   */
  function preisSetzen(karte, kachel) {
    const preis = kachel.dataset.preis;
    if (!preis) return;

    const aktuell = karte.querySelector('[data-price-current] .money')
      || karte.querySelector('[data-price-current]');
    if (aktuell) aktuell.textContent = geld(Number(preis));

    const alt = karte.querySelector('[data-price-compare]');
    if (!alt) return;

    const vergleich = Number(kachel.dataset.vergleich || 0);
    if (vergleich > Number(preis)) {
      const feld = alt.querySelector('.money') || alt;
      feld.textContent = geld(vergleich);
      alt.style.display = '';
    } else {
      alt.style.display = 'none';
    }
  }

  function waehlen(karte, knopf, leiste, kachel) {
    leiste.querySelectorAll('.qb-tile').forEach(function (t) {
      t.classList.remove('is-active');
    });
    kachel.classList.add('is-active');
    knopf.dataset.variantId = kachel.dataset.variantId;
    knopf.dataset.hasVariants = 'false';
    if (knopf.dataset.productHandle) gewaehlt.set(knopf.dataset.productHandle, kachel.dataset.variantId);
    bildTauschen(karte, kachel);
    preisSetzen(karte, kachel);
  }

  async function kachelnBauen(karte) {
    if (karte.dataset.kokoroTiles) return;

    const knopf = karte.querySelector(KNOPF);
    if (!knopf || knopf.dataset.hasVariants !== 'true') return;

    const handle = knopf.dataset.productHandle;
    if (!handle) return;

    /* Sofort markieren, sonst baut der Beobachter waehrend des Ladens erneut. */
    karte.dataset.kokoroTiles = 'laedt';

    const daten = await produkt(handle);
    const varianten = daten && daten.variants;
    const optionen = (daten && daten.options) || [];

    if (!varianten || varianten.length < 2 || optionen.length > 1) {
      karte.dataset.kokoroTiles = 'nein';
      return;
    }

    const ziel =
      karte.querySelector('.cart-upsell-product-card__title')?.parentElement ||
      karte.querySelector('.cart-upsell-product-card__content');
    if (!ziel) {
      karte.dataset.kokoroTiles = 'nein';
      return;
    }

    const leiste = document.createElement('div');
    leiste.className = 'qb-tiles kokoro-upsell-tiles';
    leiste.style.marginTop = '6px';

    let ersteFreie = null;

    varianten.forEach(function (v) {
      const kachel = document.createElement('button');
      kachel.type = 'button';
      kachel.className = 'qb-tile' + (v.available ? '' : ' is-unavailable');
      kachel.dataset.variantId = String(v.id);
      kachel.dataset.preis = String(v.price);
      if (v.compare_at_price) kachel.dataset.vergleich = String(v.compare_at_price);
      kachel.title = v.title;
      kachel.setAttribute('aria-label', v.title);

      const bild = v.featured_image && v.featured_image.src;
      if (bild) {
        kachel.dataset.bild = bild;
        kachel.style.setProperty('--qb-tile-bg', 'url("' + klein(bild) + '")');
      }

      kachel.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!v.available) return;
        waehlen(karte, knopf, leiste, kachel);
      });

      if (v.available && !ersteFreie) ersteFreie = kachel;
      leiste.appendChild(kachel);
    });

    ziel.appendChild(leiste);
    karte.dataset.kokoroTiles = 'ja';

    const gemerkt = gewaehlt.get(handle);
    const vorher = gemerkt && leiste.querySelector('.qb-tile[data-variant-id="' + gemerkt + '"]:not(.is-unavailable)');
    if (vorher || ersteFreie) waehlen(karte, knopf, leiste, vorher || ersteFreie);
  }

  /*
   * Das Theme schreibt in den Vorschlagskarten mehrere Texte fest auf
   * Englisch ins Skript: waehrend des Hinzufuegens "Adding...", danach
   * "Added!", bei ausverkauften Farben "Sold out". Dazu kommt der
   * Knopftext selbst: beim ersten Aufbau der Seite steht dort das deutsche
   * "Hinzufuegen", nach jeder Warenkorb-Aenderung baut das Theme die Karte
   * neu und liefert "Add" zurueck.
   *
   * Diese Uebersetzung laeuft bei jedem Durchlauf mit. Sie ersetzt nur
   * vollstaendige Texte, damit nichts halb uebersetzt stehen bleibt.
   */
  var TEXTE = {
    'Add': 'Hinzufügen',
    'Add to cart': 'In den Warenkorb',
    'Adding...': 'Wird hinzugefügt...',
    'Added!': 'Hinzugefügt!',
    'Added': 'Hinzugefügt',
    'Sold out': 'Ausverkauft'
  };

  function eindeutschen() {
    document.querySelectorAll(
      '.cart-upsell-product-card__button, .cart-upsell-product-card__button span,' +
      '.cart-upsell-product-card__unavailable'
    ).forEach(function (el) {
      if (el.children.length) return;
      var text = el.textContent.trim();
      if (TEXTE[text]) el.textContent = TEXTE[text];
    });
  }

  function durchlauf() {
    document.querySelectorAll(KARTE).forEach(kachelnBauen);
    eindeutschen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', durchlauf);
  } else {
    durchlauf();
  }

  /*
   * Die Karten entstehen erst zur Laufzeit und werden nach jedem Hinzufuegen
   * neu aufgebaut. Der Beobachter faengt beides ab. Das Datenattribut auf der
   * Karte verhindert, dass unsere eigene Aenderung eine Endlosschleife ausloest.
   */
  /*
   * Bewusst setTimeout statt requestAnimationFrame: der Browser haelt
   * requestAnimationFrame an, sobald der Tab im Hintergrund liegt oder das
   * Fenster nicht gezeichnet wird. Genau dann kamen die Karten nach einem
   * Hinzufuegen ohne Farbkacheln und mit englischem Knopftext zurueck, weil
   * dieser Durchlauf nie startete. Ein Zeitgeber laeuft auch dann.
   */
  let wartet = false;
  const UPSELL = KARTE + ', .cart-upsell-product-card__button, .cart-upsell-product-card__unavailable';
  new MutationObserver(function (records) {
    if (wartet) return;
    let relevant = false;
    for (const record of records) {
      const t = record.target;
      if (t.nodeType === 1 && t.closest(UPSELL)) { relevant = true; break; }
      for (const n of record.addedNodes) {
        if (n.nodeType === 1 && (n.matches(UPSELL) || n.querySelector(UPSELL))) { relevant = true; break; }
      }
      if (relevant) break;
    }
    if (!relevant) return;
    wartet = true;
    /*
     * Sofort im Beobachter laufen lassen: der laeuft noch vor dem naechsten
     * Zeichnen, so tauchen die Kacheln ohne Springen auf. Funktioniert auch im
     * Hintergrund-Tab, anders als requestAnimationFrame. Unsere eigenen
     * Aenderungen loesen keinen weiteren Aufbau aus (Markierung an der Karte).
     */
    durchlauf();
    wartet = false;
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*
 * Runde Buttons auch im Rabatt-Popup der App "Shopify Forms" (02.10.2026).
 * Das Formular steckt in einem Shadow DOM, dort kommt das Theme-CSS nicht
 * hin. Deshalb wird ein kleiner Style direkt in den Shadow Root gehaengt,
 * sobald das Formular auftaucht.
 */
(function () {
  // Absende-Knopf ("5 EUR Rabatt sichern") im Kokoro-Gruen mit weisser Schrift.
  var CSS = 'button { border-radius: 999px !important; }' +
    '[class*="formSubmitButton"] { font-weight: 700 !important; background: #5E887E !important; border-color: #5E887E !important; color: #fff !important; }' +
    // Wie die Shop-Buttons: Schrift Inter statt Poppins (der App), gleiche
    // Hoehe (52px) und Innenabstaende wie "Jetzt Waerme sichern".
    '[class*="formSubmitButton"], [class*="formSubmitButton"] *, [class*="teaserContainer"] [class*="teaserHeading"] { font-family: var(--font-body--family, "Inter", sans-serif) !important; letter-spacing: normal !important; }' +
    '[class*="formSubmitButton"] { padding: 16px 24px !important; line-height: 1.4 !important; height: auto !important; min-height: 0 !important; }' +
    '[class*="formSubmitButton"] * { color: #fff !important; }' +
    '[class*="formSubmitButton"]:hover { background: #2F6355 !important; border-color: #2F6355 !important; }' +
    // Reiter "5 EUR SPAREN" unten links, der nach dem Schliessen des Popups bleibt.
    '[class*="teaserContainer"] { background: #5E887E !important; border-color: #5E887E !important; color: #fff !important; }' +
    '[class*="teaserContainer"] [class*="teaserHeading"] { font-weight: 700 !important; }' +
    '[class*="teaserContainer"] *, [class*="teaserContainer"] svg, [class*="teaserContainer"] path { color: #fff !important; fill: currentColor; }' +
    // Kleiner als im Original (163 x 66 px): weniger Innenabstand, kleinere Schrift.
    '[class*="teaserContainer"] { padding: 10px 16px !important; gap: 8px !important; }' +
    // Die App gibt dem Reiter einen grossen weichen Schatten (80px), der wie ein
    // grauer, halbdurchsichtiger Fleck darunter wirkte. Ersetzt durch einen dezenten.
    '[class*="teaserContainer"] { box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important; }' +
    // Schriftgroesse aus dem Regler "Schriftgroesse aller Button-Texte"
    // (Variable --kokoro-button-size aus snippets/kokoro-stil.liquid, Shadow DOM
    // erbt sie). Ohne Variable bleibt der Reiter bei 14px, der Absende-Knopf
    // bei der Groesse aus der App.
    '[class*="teaserContainer"] [class*="teaserHeading"] { font-size: var(--kokoro-button-size, 14px) !important; line-height: 20px !important; }' +
    '[class*="teaserContainer"] svg { width: 10px !important; height: 10px !important; }' +
    '[class*="teaserContainer"]:hover { background: #2F6355 !important; border-color: #2F6355 !important; }' +
    // Mit Fuell-Effekt: kein Schatten unter dem Rand (wirkte wie ein dunkler
    // Fleck an der Unterkante) und Schrift + X ohne Verzoegerung umfaerben,
    // sonst ist das X kurz hellgrau.
    '[class*="teaserContainer"].kokoro-wipe.is-hover [class*="teaserHeading"], [class*="teaserContainer"].kokoro-wipe.is-hover [class*="CloseButton"], [class*="teaserContainer"].kokoro-wipe.is-hover svg, [class*="teaserContainer"].kokoro-wipe.is-hover path { transition: none !important; }';

  function einhaengen(root) {
    if (root.querySelector('style[data-kokoro-rund]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-kokoro-rund', '');
    var groesse = getComputedStyle(document.documentElement).getPropertyValue('--kokoro-button-size').trim();
    // Styles des Fuell-Effekts (aus snippets/kokoro-stil.liquid) auch hier
    // hinein, sonst greift der Effekt im Popup nicht.
    var stil = Array.prototype.find.call(document.querySelectorAll('style'), function (el) {
      return el.textContent.indexOf('.kokoro-clip') > -1;
    });
    style.textContent = CSS + (groesse
      ? '[class*="formSubmitButton"], [class*="formSubmitButton"] * { font-size: var(--kokoro-button-size) !important; }'
      : '') + (stil ? stil.textContent : '');
    root.appendChild(style);
  }

  // Die App baut den Inhalt beim Oeffnen des Popups neu auf und wirft dabei
  // unseren Style raus. Der Beobachter haengt ihn sofort wieder ein, noch
  // bevor der Browser zeichnet - sonst blitzt der Knopf kurz schwarz auf.
  // Grundfarbe von Reiter und Absende-Knopf merken, solange die Maus noch
  // nicht drauf ist. Beim Hover faerbt die App sie sofort dunkler, dann
  // wuerde der Fuell-Effekt Rand und Schrift im falschen Gruen zeichnen.
  function farbenMerken(root) {
    root.querySelectorAll('[class*="teaserContainer"],[class*="formSubmitButton"]').forEach(function (btn) {
      if (btn.dataset.kokoroFarbe || btn.matches(':hover')) return;
      btn.dataset.kokoroFarbe = getComputedStyle(btn).backgroundColor;
    });
  }

  function runden() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (el) {
      var root = el.shadowRoot;
      if (!root) return;
      einhaengen(root);
      farbenMerken(root);
      if (el.dataset.kokoroRund) return;
      el.dataset.kokoroRund = 'ja';
      new MutationObserver(function () {
        einhaengen(root);
        farbenMerken(root);
      }).observe(root, { childList: true, subtree: true });
    });
  }

  // Shadow Root direkt beim Anlegen erwischen, falls das Formular erst nach
  // diesem Skript entsteht.
  var original = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = original.call(this, init);
    if (this.localName === 'shopify-forms-embed') setTimeout(runden, 0);
    return root;
  };

  // Reiter "5 EUR SPAREN" ueber den Cookie-Banner heben, solange der offen ist.
  // Sonst verdeckt der Reiter "Praeferenzen verwalten" bzw. den Bannertext.
  // Nach dem Wegklicken des Banners rutscht er wieder an seinen Platz.
  function ueberCookieBanner() {
    var box = document.querySelector('.tinycookie-box');
    var rect = box && box.getBoundingClientRect();
    var offen = rect && rect.height > 0 && rect.top < window.innerHeight;
    var hoch = offen ? Math.max(0, Math.round(window.innerHeight - rect.top) + 8) + 'px' : null;
    document.querySelectorAll('shopify-forms-embed').forEach(function (el) {
      var root = el.shadowRoot;
      if (!root) return;
      root.querySelectorAll('[class*="appEmbedRootTeaser"]').forEach(function (embed) {
        // Die App setzt "bottom" selbst als Inline-Style. Den Wert merken und
        // nach dem Schliessen des Banners zurueckgeben, sonst rutscht der
        // Reiter aus dem Bild.
        if (embed.dataset.kokoroBottom === undefined) {
          embed.dataset.kokoroBottom = embed.style.bottom || getComputedStyle(embed).bottom;
        }
        var ziel = hoch || embed.dataset.kokoroBottom;
        if (embed.style.bottom !== ziel) embed.style.bottom = ziel;
      });
    });
  }
  setInterval(ueberCookieBanner, 500);
  window.addEventListener('resize', ueberCookieBanner);

  runden();
  var versuche = 0;
  var timer = setInterval(function () {
    runden();
    if (++versuche > 1200) clearInterval(timer);
  }, 250);
})();

/*
 * Button-Hover wie bei Stoov (02.10.2026): eine ovale Flaeche gleitet beim
 * Drueberfahren von unten ueber den Button und beim Verlassen nach oben wieder
 * heraus. Aussehen und Schalter: Theme-Einstellungen "Kokoro: Preise &
 * Buttons" -> snippets/kokoro-stil.liquid (setzt --kokoro-wipe).
 *
 * Ueber Ereignis-Delegation am Dokument, weil Warenkorb und Bundle-Box ihre
 * Buttons zur Laufzeit neu aufbauen. Die Flaeche wird beim ersten Hover
 * eingesetzt und bei Bedarf neu angelegt. Nicht auf Touch-Geraeten.
 */
(function () {
  var BUTTONS = [
    '.button:not(.cart-upsell-product-card__button):not(.skip-to-content-link)',
    '.add-to-cart-button',
    '.fbt__button',
    '.promo-cta__btn',
    '.tinycookie-accept-all',
    '.jdgm-write-rev-link',
    '.jdgm-btn'
  ].join(',');

  // Reiter "5 EUR SPAREN" und Absende-Knopf im Rabatt-Popup (Shadow DOM).
  var ALLE = BUTTONS + ',[class*="teaserContainer"],[class*="formSubmitButton"]';

  if (!window.matchMedia || !window.matchMedia('(any-hover: hover)').matches) return;

  function finde(event) {
    var pfad = event.composedPath ? event.composedPath() : [event.target];
    for (var i = 0; i < pfad.length; i++) {
      var el = pfad[i];
      if (el === document.body || el === document) break;
      if (el.nodeType === 1 && el.matches && el.matches(ALLE)) return el;
    }
    return null;
  }

  function aktiv() {
    return getComputedStyle(document.documentElement).getPropertyValue('--kokoro-wipe').trim() === '1';
  }

  // Huelle und Rand reichen bis zur Aussenkante: absolut positionierte
  // Elemente beginnen sonst innerhalb eines eigenen Button-Randes.
  // Die Huelle der Flaeche beginnt an der Aussenkante (auch ueber einen
  // eigenen Button-Rand) und endet innen am 2px-Rand, der am Button selbst
  // gezeichnet wird.
  function aussenkante(el, cs) {
    var ring = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--kokoro-ring')) || 0;
    el.style.top = (ring - parseFloat(cs.borderTopWidth)) + 'px';
    el.style.right = (ring - parseFloat(cs.borderRightWidth)) + 'px';
    el.style.bottom = (ring - parseFloat(cs.borderBottomWidth)) + 'px';
    el.style.left = (ring - parseFloat(cs.borderLeftWidth)) + 'px';
  }

  function flaeche(button) {
    var cs = getComputedStyle(button);
    var clip = button.querySelector(':scope > .kokoro-clip');
    if (!clip) {
      clip = document.createElement('span');
      clip.className = 'kokoro-clip';
      clip.setAttribute('aria-hidden', 'true');
      var neu = document.createElement('span');
      neu.className = 'kokoro-fill';
      clip.appendChild(neu);
      button.insertBefore(clip, button.firstChild);
    }
    aussenkante(clip, cs);
    button.classList.add('kokoro-wipe');
    return clip.firstChild;
  }

  // Grundfarbe des Buttons einmal merken, bevor er sich durch den Hover
  // veraendert. Schrift und Rand beim Hover bekommen genau diese Farbe.
  // Durchsichtige Buttons nehmen ihre Schriftfarbe.
  function grundfarbe(button) {
    if (button.dataset.kokoroFarbe) return button.dataset.kokoroFarbe;
    var cs = getComputedStyle(button);
    var farbe = cs.backgroundColor;
    var alpha = farbe.match(/rgba\([^)]*,\s*([\d.]+)\)/);
    if (farbe === 'transparent' || (alpha && parseFloat(alpha[1]) < 0.5)) farbe = cs.color;
    button.dataset.kokoroFarbe = farbe;
    return farbe;
  }

  function rein(button) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true' || !aktiv()) return;
    if (!(button.innerText || '').trim()) return;
    button.style.setProperty('--kokoro-btn-color', grundfarbe(button));
    var fill = flaeche(button);
    fill.classList.remove('is-in', 'is-out');
    fill.classList.add('is-start');
    void fill.offsetWidth;
    fill.classList.remove('is-start');
    fill.classList.add('is-in');
    button.classList.add('is-hover');
  }

  function raus(button) {
    var fill = button.querySelector(':scope > .kokoro-clip > .kokoro-fill');
    button.classList.remove('is-hover');
    if (!fill) return;
    fill.classList.remove('is-in');
    fill.classList.add('is-out');
  }

  document.addEventListener('pointerover', function (event) {
    if (event.pointerType === 'touch') return;
    var button = finde(event);
    if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;
    rein(button);
  });

  document.addEventListener('pointerout', function (event) {
    var button = finde(event);
    if (!button || (event.relatedTarget && button.contains(event.relatedTarget))) return;
    raus(button);
  });
})();

/* Cookie-Banner: Das Keks-Emoji in der kursiven Überschrift steht sonst schräg.
   Emojis in einen eigenen, nicht kursiven Span packen (CSS: .kokoro-emoji). */
(function () {
  var EMOJI = /(\p{Extended_Pictographic}\uFE0F?)/gu;

  function richteEin() {
    var titel = document.querySelector('#tinycookie-wrapper .tinycookie-title');
    if (!titel || titel.querySelector('.kokoro-emoji')) return !!titel;
    titel.innerHTML = titel.innerHTML.replace(EMOJI, '<span class="kokoro-emoji">$1</span>');
    return true;
  }

  if (richteEin()) return;
  var beobachter = new MutationObserver(function () {
    if (richteEin()) beobachter.disconnect();
  });
  beobachter.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { beobachter.disconnect(); }, 15000);
})();
